import { html, type TemplateResult } from '@design.estate/dees-element';
import type { DeesChartRadar } from './component.js';

export const renderChartRadar = (component: DeesChartRadar): TemplateResult => {
  return html`
    <dees-tile>
      <div slot="header" class="chartHeader">
        <span class="chartLabel">${component.label}</span>
      </div>
      <div class="chartContainer"></div>
    </dees-tile>
  `;
};
